module.exports = __webpack_public_path__ + "static/on-death-and-dying-c4c09088a1d2e0a67dff1f5e8da73369.jpg";